import React, { useEffect, useState } from "react";
import "./BigTitle.scss";

function BigTitle({ title }) {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="groupe-37">
      <h1
        className="title h2"
        style={{
          width:
            size.width > 1300
              ? size.width > 1919
                ? "93%"
                : size.width > 1600
                ? size.width > 1700
                  ? "95%"
                  : "97%"
                : "100%"
              : "95%",
        }}
      >
        {title}
      </h1>
    </div>
  );
}

export default BigTitle;
